import { Exact } from "src/generated/graphql";
import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import { Apollo, Query, Mutation } from "apollo-angular";

export class Action {
  id: string;
  code: string;
  title: string;
  description: string;
  status: "pending" | "in progress" | "done" | "canceled";

  isDescriptionVisible?: boolean;
  isStatusModalVisible?: boolean;

  ideaId: string;
  responsibleId: string;

  idea: {
    id: string
    code: string;
    title: string;
  };

  responsible: {
    id: string;
    name: string;
  };

  comments: {
    id: string;
    comment: string;
    createdAt: Date;
  }[]

  startDate: Date;
  endDate: Date | string;
  createdAt: Date;
  updatedAt: Date;
}

export type GetAllActionsQueryVariables = Exact<{ id: string }>;

export type GetAllActionsQuery = {
  getAllActions: {
    id: string;
    code: string;
    title: string;
    description: string;
    status: "pending" | "in progress" | "done" | "canceled";

    isDescriptionVisible?: boolean;
    isStatusModalVisible?: boolean;

    responsibleId: string;
    ideaId: string;

    idea: {
      id: string
      code: string;
      title: string;
    };

    responsible: {
      id: string;
      name: string;
    };

    comments: {
      id: string;
      comment: string;
      createdAt: Date;
    }[]

    startDate: Date;
    endDate: Date | string;
    createdAt: Date;
    updatedAt: Date;
  }[];
};

export const GetAllActionDocument = gql`
  query GetAllActions($id: String) {
    getAllActions(id: $id) {
      id
      title
      description
      status
      startDate
      endDate
      createdAt

      idea {
        id
        title
        code
      }

      responsible {
        id
        name
      }

      tasks {
        id
      }

      comments {
        id
        comment
        createdAt

        user {
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetAllActionsGQL extends Query<
  GetAllActionsQuery,
  GetAllActionsQueryVariables
> {
  document = GetAllActionDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}

// --------------------------

export type DeleteActionMutationVariables = Exact<{ id: string, ideaId?: string }>;

export type DeleteActionMutation = {
    deleteAction: {
      message?: string;
    }
};

export const DeleteActionDocument = gql`
  mutation DeleteAction($id: String!, $ideaId: String) {
    deleteAction(id: $id, ideaId: $ideaId) {
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteActionGQL extends Mutation<
  DeleteActionMutation,
  DeleteActionMutationVariables
> {
  document = DeleteActionDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}

// --------------------------

export type  UpdateAllActionsMutationVariables = Exact<{
  input: {
    actions: {id: string, status: string}[] 
  }
}>;

export type  UpdateAllActionsMutation = {
    updateAllActions: {
      message?: string;
    }
};

export const  UpdateAllActionsDocument = gql`
  mutation UpdateAllActions($input: UpdateAllActionsInput!) {
     updateAllActions(data: $input) {
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class  UpdateAllActionsGQL extends Mutation<
   UpdateAllActionsMutation,
   UpdateAllActionsMutationVariables
> {
  document =  UpdateAllActionsDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}

